import React, { useState, useMemo } from "react";
import { Form, AutoComplete } from "antd";
import { debounce } from "lodash";
import {
  GetJobTemplateTitleInfo,
  GetPostAJobTitles,
} from "../../../pages/api/Employer/Employer";
import { createUseStyles } from "react-jss";

const UIAutoCompleteInput = ({
  FieldType,
  label,
  name,
  required,
  rules,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  defaultValue,
  placeholder = "",
  onGetData,
  source,
}) => {
  const [listOptions, setListOptions] = useState([]);
  // Fetch job titles
  const getPostAJobTitles = async (title = "") => {
    if (!title) {
      setListOptions([]);
      return;
    }

    const response = await GetPostAJobTitles(title);
    const postAJobTitles = response?.Data || [];

    const arr = postAJobTitles.map((item, index) => ({
      label: item?.DataFields?.JobTitle || "",
      value: item?.DataFields?.JobTitle || "",
      FieldId: item?.FieldId,
      key: `${item?.FieldId || index}`,
    }));

    setListOptions(arr);
  };

  // Debounced version of API call
  const debouncedGetPostAJobTitles = useMemo(
    () => debounce(getPostAJobTitles, 300),
    []
  );

  const handleSelect = async (val, option) => {
    if (option?.FieldId) {
      const response = await GetJobTemplateTitleInfo(option.FieldId);
      onGetData?.(response);
    }
  };

  const styles = useStyles();
  return (
    <Form.Item
      label={<span style={{ fontSize: "16px", fontWeight: "500" }}>{label}</span>}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue || ""}
    >
      <AutoComplete
        options={listOptions}
        onSelect={handleSelect}
        onChange={(text) => {
          if (FieldType === "JobTemplateTitles") {
            debouncedGetPostAJobTitles(text);
          }
        }}
        allowClear
        className={source === "JobPostForm" ? styles.customSelectJobPost : styles.customSelect}
        placeholder={placeholder}
        disabled={disabled}
        filterOption={false} // Important: disables local filtering
        defaultActiveFirstOption={false}
      />
    </Form.Item>
  );
};

export default UIAutoCompleteInput;
const useStyles = createUseStyles({
  customSelect: {
    width: "100%",
    height: "40px",
    "& .ant-select-selector": {
      overflow: "auto",
      fontsize: "16px"
    },
  },
  customSelectJobPost: {
    width: "100%",
    height: "40px",
    border: "1px solid #e5e7eb",
    borderRadius: 22,
    height: 42,
    display: "flex",
    alignItems: "center",
    boxShadow: "0 12px 35px rgba(15, 23, 42, 0.04)",
    "& .ant-select-selector": {
      overflow: "auto",
      fontsize: "16px"
    },
  }
});